// The web app's concrete store. The portable factory, reducer, and redaction
// logic now live in the shared workspace package `@healthshare/shared` (see
// packages/shared and docs/plans/embeddable-sdk.md) so the Expo app and the SDK
// can build their own store the same way, with their own persistence engine and
// no Sentry dependency. This file supplies the web-only pieces: localStorage,
// `@sentry/react`, and the concrete `store`/`persistor` singleton.
import * as Sentry from '@sentry/react'
import storage from 'redux-persist/lib/storage'
import { createStore, redactState } from '@healthshare/shared/reduxToolkit/store'
import { redactAction } from '@healthshare/shared/reduxToolkit/redactAction'
import type { RootState } from '@healthshare/shared/reduxToolkit/store'

export * from '@healthshare/shared/reduxToolkit/store'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: redactAction,
  stateTransformer: (state: RootState) => {
    // Transform the state to remove sensitive information
    return redactState(state)
  },
})

const webStore = createStore({
  storage,
  enhancers: [sentryReduxEnhancer],
})

export const store = webStore.store
export const persistor = webStore.persistor

// `AppDispatch` is NOT redeclared here. The shared `createStore` composes the
// web store the same way regardless of the persistence engine or enhancers
// passed to it, so `@healthshare/shared`'s `AppDispatch` (from the `export *`
// above) already equals `typeof store.dispatch` -- redeclaring it locally
// would only shadow that export with a second, easy-to-drift definition of
// the same public name.
